import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";

import Select from 'react-select';

class  TagsComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {

          
            data: null,
            filtered: []


        };

    }
    componentDidMount() {
        // This method is called when the component is first added to the document

        this.ensureDataFetched();

    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        this.ensureDataFetched();
    }

    ensureDataFetched() {
     //   const shortlistID = this.props.match.params.shortlistID;
        // this.props.requestWeatherForecasts(startDateIndex);
   //     this.props.getShortList(shortlistID);
        this.props.requestAssetTagslist(0);
        this.props.requestTags("mood");
        this.props.requestTags("environmental");
        this.props.requestTags("audio_quality");
        this.props.requestTags("audio");
        this.props.requestTags("instrument");

    }

    reorder(list, startIndex, endIndex) {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    moveSingleTrack(e) {
        var asset = this.props.tempShortList.filter(t => t.code == e.dataTransfer.getData("text"));
        if (asset != null) {
            this.props.AddSingeAssetToShortList(asset[0]);
        }
    }

    selectTrack(e) {

        var track = this.props.assetTagsList.filter(a => a.isrc == e);
        this.props.SetTagModel(track[0]);     
    }

    setData() {

        let arr = [];
        arr = this.props.selectedinstruments.concat(this.props.selectedaudio_tags).concat(this.props.selectedaudio_quality).concat(this.props.selectedMoods).concat(this.props.selectedEnvironmental);
        if (arr !== []) {
            this.props.SetTagToISRC(arr, this.props.selectedTagModel.isrc);
        }

    }

    goUp(data) {

        let index;
        if (data.target) {
            index = parseInt(data.target.value);
        } else {
            index = parseInt(data);
        }


        let items = this.reorder(
            this.props.tempShortList,
            index,
            index == 0 ? 0 : index - 1
        );
        console.info(items);

        this.props.sortTempTracks(items);
      //  this.props.updateShortList();
    }


    renderData() {
        let asset = this.props.selectedTagModel;

        if (asset != null) {
            return <div>
                <h2>{asset.name}</h2>
                <h3>{asset.tags}</h3>               
            </div>
        }

    }

    renderScreen() {
        return (<div>
                <div className="filter-bar">
                    {this.renderData()}
                    <table className="filter-table">
                        <tbody>
                            <tr>

                                <td>
                                    <p>Generic Audio Tags</p>
                                    <Select
                                        isLoading={this.props.isLoadingAudioTags}
                                        name="form-field-name"
                                        value={this.props.selectedaudio_tags}
                                        options={this.props.audio_tags}
                                        isMulti
                                        onChange={(data) => this.props.SetAudioTag(data)}
                                        disabled={this.props.isLoadingAssetTagsList}

                                    /></td><td>
                                    <p>Moods</p>
                                    <Select
                                        isLoading={this.props.isLoadingMoods}
                                        name="form-field-name"
                                        value={this.props.selectedMoods}
                                        options={this.props.moods}
                                    isMulti={true}
                                        onChange={(data) => this.props.SetMood(data)}
                                        disabled={this.props.isLoadingAssetTagsList}

                                    /></td></tr>

                            <tr>

                                <td>
                                    <p>Instruments</p>
                                    <Select
                                        isLoading={this.props.isLoadingInstruments}
                                        name="form-field-name"
                                        value={this.props.selectedinstruments}
                                        options={this.props.instruments}
                                        isMulti={true}
                                        onChange={(data) => this.props.SetInstruments(data)}
                                        disabled={this.props.isLoadingAssetTagsList}

                                    /></td>
                                <td>
                                    <p>Audio Quality</p>
                                    <Select
                                        isLoading={this.props.isloadingQuality}
                                        name="form-field-name"
                                        value={this.props.selectedaudio_quality}
                                        options={this.props.audio_quality}
                                        isMulti={false}
                                        onChange={(data) => this.props.SetAudioQuality(data)}
                                        disabled={this.props.isLoadingAssetTagsList}

                                    /></td>
                            </tr>
                            <tr>

                                <td>
                                    <p>Environmental</p>
                                    <Select
                                        isLoading={this.props.isLoadingEnvironmental}
                                        name="form-field-name"
                                        value={this.props.selectedEnvironmental}
                                        options={this.props.environmental}
                                        isMulti={true}
                                        onChange={(data) => this.props.SetEnvironmental(data)}
                                        disabled={this.props.isLoadingAssetTagsList}

                                /></td>
                            <td style={{ textAlign: 'center', paddingTop: '10px' }}>  <button disabled={this.props.isSavingTags} onClick={() => this.setData()}> Update Tags </button><button style={{ textAlign: 'center', marginLeft: '20px' }} disabled={this.props.isSavingTags} onClick={() => this.props.clearTags()}> Clear Tags </button></td>
                            
                            </tr>

                            <tr></tr>


                        </tbody>
                    </table>
                </div>
                <div className="search-table-container">
                  
                {this.renderReactTable(this.props.assetTagsList, this.props, this)}

                    {/*this.props.tempShortList != null && this.props.tempShortList.length > 0 ? this.renderSortableList() : ''*/}
                </div>
               </div>

      )
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;//this.props.filtered;
        let insertNewFilter = 1;



        if (filtered.length) {
            filtered.forEach((filter, i) => {
                if (filter["id"] === accessor) {
                    if (value === "" || value === null) filtered.splice(i, 1);
                    else filter["value"] = value;
                    insertNewFilter = 0;
                }
            });
        }

        if (insertNewFilter) {
            filtered.push({ id: accessor, value: value });
        }




        //this.props.setCatalogueFilter(filtered);
        this.setState({ filtered: filtered });
    };
   

  
     renderReactTable(data, props, main) {


    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {

                style: {
                    background: props.selectedTagModel && props.selectedTagModel.isrc === rowInfo.original.isrc? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',

                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}

            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                if (typeof filter.value === "object") {
                    return row[id] !== undefined || row[id] !== null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}


            columns={[
                {
                    Header: "Basic Data",
                    columns: [
                        {
                            Header: "ISRC",
                            accessor: "isrc",
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => main.selectTrack(row.value)}> {row.value}</span>
                            )
                        },
                        {
                            Header: "Audio",
                            accessor: "fugaId",
                            Cell: row => (
                                <button onClick={() => props.setAudioUrl(row.value)}> {props.audioURL === row.value ? "Playing" : "Play"}</button>
                            ),
                            Filter: ({ filter, onChange }) => {
                                return ("")
                            }
                        },
                        {
                            Header: "Title",
                            accessor: "name"
                        },
                        {
                            Header: "Artist",
                            accessor: "artist"
                        },                        
                        {
                            Header: "Tags",
                            accessor: "tags",
                            Cell: row => <div><span title={row.value}>{row.value}</span></div>
                        },

                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};


    renderForecastsTable() {
        let data = this.props.assetTagsList;

        return <table className='table table-hover search'>
            <thead>
                <tr>
                    <th></th>
                    <th>ISRC</th>
                    <th>Name</th>
                    <th>Artist</th>
                    <th>Tags</th>
                    <th>Audio</th>
                </tr>
            </thead>
            <tbody>
                {
                    !this.props.isLoadingAssetTagsList ? data.map(product =>
                        <tr className={product.hasTags ? "bg-success" : ""} key={product.isrc}>
                            <td><Link to={'/detail/asset/' + product.isrc}><span className='glyphicon glyphicon-search'></span></Link></td>
                            <td>{product.isrc}</td>
                            <td>{product.name}</td>
                            <td>{product.artist}</td>
                            <td>{product.tags}</td>
                            <td>   <button onClick={() => this.props.setAudioUrl(product.fugaId)}> {this.props.audioURL === product.fugaId ? "Playing" : "Play"}</button></td>
                            <td><button className='btn btn-default' value={product.isrc} onClick={this.selectTrack.bind(this)}> {this.props.selectedTagModel != null && this.props.selectedTagModel.isrc === product.isrc ? '√' : 'X'} </button></td>

                        </tr>
                    )
                        : []}

            </tbody>
        </table>;
    }
   

    render() {
        
        return <div>
           
            <h1>Update Tags</h1>
            {this.renderScreen()}
            


        </div>
        
    }
}








export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(TagsComponent);



// WEBPACK FOOTER //
// ./src/components/Tags.js